export const PaymentSuccess = () => {
  return <div></div>;
};
